(function () {
    const second = 1000,
          minute = second * 60,
          hour = minute * 60,
          day = hour * 24;

    // Get the supplied event date
    var element = document.getElementById("cd-component");
    if (element) {
        eventData = document.getElementById("cd-component").getAttribute("data-date");
        var dst = document.getElementById("cd-component").getAttribute("data-dst");
        //convert the supplied event date to central time
        var setDate = new Date(eventData);
        var setDateEpoch = setDate.getTime();
        x = setInterval(function() {    
                // Get the current date/time in central time and subtract it fomr the event date
                var nowTimeCentral = getTimezoneNow(-300);
                timeDifference = setDateEpoch - nowTimeCentral;

            //calculate if less than one day remains, if true hide the days counter
            var daysRemaining = Math.floor(timeDifference / (day)),
                daysCounter = document.getElementById("days-value");
            if(daysCounter && daysRemaining < 1) {
                document.getElementById("days-value").remove();
            } else if(daysCounter) {
                document.getElementById("ct-days").innerText = daysRemaining;
            }

            document.getElementById("ct-hours").innerText = Math.floor((timeDifference % (day)) / (hour)),
            document.getElementById("ct-minutes").innerText = Math.floor((timeDifference % (hour)) / (minute)),
            document.getElementById("ct-seconds").innerText = Math.floor((timeDifference % (minute)) / second);

        }, 0)
    }
    // This isn't super reusable because it assumes you know your timezone offset.
    function getTimezoneNow(offset) {
        var timeZone = new Date();
        var z = timeZone.getTimezoneOffset();
        if (z < 0) {
            var absoluteValue = Math.abs(z);
            if(absoluteValue == offset) {
                //if user is in same zone, don't modify
                var timeNow = new Date().getTime();
                return timeNow;
            } else if (absoluteValue > offset) {
                var timeDiff = absoluteValue - offset;
                var timeNow = new Date().getTime() - (timeDiff*60*1000);
                return timeNow;
            } else if (absoluteValue < offset) {
                var timeDiff = offset - absoluteValue;
                var timeNow = new Date().getTime() + (timeDiff*60*1000);
                return timeNow;
            }
        } else {
            var absoluteValue = Math.abs(z);
            var timeDiff = absoluteValue + offset;
            var timeNow = new Date().getTime() + (timeDiff*60*1000);
            return timeNow;
        }
    }
    
    }());